import {Component, Input, OnInit} from '@angular/core';
import {LifeProjectBaseEditorComponent} from '../life-project-base-editor/life-project-base-editor.component';
import {WelfareResultService} from '../../../../service/welfare-result.service';
import {BoardProject} from '../../../../class/lifeproject/board-project';
import {Person} from '../../../../class/person';
import {PersonKind} from '../../../../class/person-kind.enum';
import {PersonRetirement} from '../../../../class/lifeproject/retirement/person-retirement';
import {RetirementType} from '../../../../class/lifeproject/retirement-type.enum';
import {EphesoAnalisys} from '../../../../class/lifeproject/retirement/epheso/epheso-analisys';
import {EphesoPerson} from '../../../../class/lifeproject/retirement/epheso/epheso-person';
import {EphesoIncome} from '../../../../class/lifeproject/retirement/epheso/epheso-income';
import {PosizionePrevidenzialeObbligatoria} from '../../../../class/lifeproject/retirement/epheso/posizione-previdenziale-obbligatoria';

@Component({
  selector: 'app-board-component',
  templateUrl: './board-component.component.html',
  styleUrls: ['./board-component.component.css']
})
export class BoardComponentComponent extends LifeProjectBaseEditorComponent implements OnInit {

  @Input()
  boardProject: BoardProject;

  type: RetirementType;

  showApproveOption = false;

  simpleView = RetirementType.SIMPLE;
  adavacedView = RetirementType.ANIA;

  constructor(welfareProject: WelfareResultService) {
    super(welfareProject);
  }

  ngOnInit() {

    if (this.boardProject && this.boardProject.personRetirement == null) {
      this.retirement = new PersonRetirement();
    }

    if (this.boardProject && this.boardProject.aniaResponse) {
      this.type = RetirementType.ANIA;
    }

    this.showApproveOption = this.boardProject.createIntegration;
  }

  get family() {
    return this.serviceProject.persons;
  }

  getLifeProjectImpl() {
    return this.boardProject;
  }

  get retirement() {
    return this.boardProject.personRetirement;
  }

  set retirement(value: PersonRetirement) {
    this.boardProject.personRetirement = value;
  }

  getSelectablePerson(): Person[] {
    const people = [];
    if (this.family) {
      this.family.forEach(value => {
        if (value.kind === PersonKind.HUSBAND || value.kind === PersonKind.WIFE || value.kind === PersonKind.SINGLE) {
          people.push(value);
        }
      });
    }
    return people;
  }

  setSelectedPerson(person: Person) {
    this.retirement.person = person;
  }

  setRetirementView(advanced: boolean) {
    this.type = advanced ? RetirementType.ANIA : RetirementType.SIMPLE;
  }

  totalPersonIncome() {
    return this.retirement.person.income + this.retirement.person.secondIncome;
  }
}
